import React from 'react';
import cn from 'classnames';
import IntervalStatusContainer, {
  intervalStatusTypes,
} from '../../../ui/IntervalStatusContainer';
import IntervalStatusIcon from '../IntervalStatusIcon';
import { formatPhoneNumber } from '../../../../../../../helpers/formatPhoneNumber';
import { createRoomAddress } from '../../../../../shared/packages/address';
import styles from './index.module.scss';

const Interval = ({ interval, action }) => {
  const { fromTime, toTime, withExpertId, isBusy, blocked, client, records } =
    interval;

  const type = isBusy
    ? intervalStatusTypes.base
    : intervalStatusTypes.baseInverted;

  return (
    <IntervalStatusContainer
      type={type}
      bordered
      className={cn(styles.root, { [styles.blocked]: blocked })}
    >
      <div className={styles.firstRow}>
        <div className={styles.periodWrap}>
          <span className={styles.period}>
            {fromTime}-{toTime}
          </span>
          <IntervalStatusIcon
            isBusy={isBusy}
            withExpertId={withExpertId}
            isExpert={interval.isExpert}
          />
        </div>
        {action}
      </div>
      {Boolean(client) && <RenderClient client={client} />}
      {Boolean(records) && <RenderAddresses addresses={records} />}
    </IntervalStatusContainer>
  );
};

export default Interval;

function RenderClient({ client }) {
  return (
    <div className={styles.recordInfo}>
      <span className="fw-600">Записан:</span>
      <span>{client.name}</span>
      {client.phone && (
        <span>
          {formatPhoneNumber({
            phoneNumber: client.phone,
            format: '(xxx) xxx-xx-xx',
            placeholder: 'x',
          })}
        </span>
      )}
      {client.email && <span>{client.email}</span>}
    </div>
  );
}

function RenderAddresses({ addresses }) {
  const dash = addresses.length > 1 ? '— ' : '';

  return (
    <div className={styles.recordInfo}>
      <span className="fw-600">Адреса:</span>
      <div className={styles.recordInfo}>
        {addresses.map((address) => (
          <span key={address.addressId}>
            {dash}
            {createRoomAddress(address)}
          </span>
        ))}
      </div>
    </div>
  );
}
